<template>
  <div class="page-wrapper">
    <div class="container" style="max-width:500px;">
      <div class="row section-padding-top">
        <div class="col-12">
          <img src="/static/img/uko-logo.png"/>
        </div>
      </div>
      <div class="row section-padding-top">
        <div class="col-12">
          <h1>UKO 관리자</h1>

        </div>
      </div>

      <div class="row form-group section-padding-top">
        <div class="col-12">
          <input type="email" class="form-control text-center" v-model="email" placeholder="이메일" @keyup.enter="signIn"/>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12">
          <input type="password" class="form-control text-center" v-model="password" placeholder="비밀번호" @keyup.enter="signIn"/>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-12 text-left">
          <input type="checkbox" v-model="autoLogin"/> Auto Login
        </div>
      </div>
      <div class="row form-group section-padding-top">
        <div class="col-12">
          <button type="button" class="btn btn-primary form-control" v-on:click="signIn">로그인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import EventBus from '../api/event-bus.js';
    import {userSignIn, getMenuItems} from '../api/user'

    export default {
        name: "Login",
        data() {
            return {
                mode:0,
                email:'',
                password:'',
                newEmail:'',
                newName:'',
                newPwd:'',
                newPwd2:'',
                newLevel: 0,
                autoLogin: false,

            }
        },
        created() {
        },
        mounted() {
          this.onStart();
        },
        methods: {
            onStart: function() {
              console.log("autoLogin " + localStorage.getItem("autoLogin"));
              console.log("email " + localStorage.getItem("email"));
              console.log("password " + localStorage.getItem("password"));
              if(localStorage.getItem("autoLogin") !== undefined && localStorage.getItem("autoLogin") !== null) {
                this.$data.autoLogin = localStorage.getItem("autoLogin");
              }
              if(this.$data.autoLogin === 'true') {
                console.log("Auto log in is set");

                // if(localStorage.getItem("email") !== undefined && localStorage.getItem("email") !== null) {
                if(localStorage.getItem("email") != null) {
                  console.log("email read ")
                  this.$data.email = localStorage.getItem("email");

                }
                if(localStorage.getItem("password") !== undefined && localStorage.getItem("password") !== null) {
                  this.$data.password = localStorage.getItem("password");
                }

                console.log("Now set " + this.$data.email + " " + this.$data.password);
                if(this.$data.email !== undefined && this.$data.email !== null && this.$data.email.length > 0
                  &&  this.$data.password !== undefined && this.$data.password !== null && this.$data.password.length > 0) {
                  this.signIn();
                }
              }

            },
            signIn: function() {
                let self = this;
                userSignIn(this.$data.email, this.$data.password)
                    .then(function(data){
                        console.log("Successful signin " + data.success);
                        console.log(data)
                        if(data.success == true) {
                            console.log("Successful signin");
                            localStorage.setItem("JSTOKEN", data.item.token);
                            localStorage.setItem("email", data.item.email);
                            localStorage.setItem("id", data.item.id);
                            localStorage.setItem("autoLogin", self.$data.autoLogin);
                            console.log("auto login " + self.$data.autoLogin);
                            if(self.$data.autoLogin == true || self.$data.autoLogin === 'true') {
                              console.log("auto login save password");
                              localStorage.setItem("password", self.$data.password);
                            }
                            EventBus.$emit("logon", true);
                            self.$router.push('/moveJobs');
                        } else {
                            localStorage.removeItem("JSTOKEN");
                            localStorage.removeItem("email");
                            localStorage.removeItem("id");
                            localStorage.removeItem("autoLogin");
                            EventBus.$emit("logon", false);
                        }
                    })
                    .catch(function(err){
                        console.log("Error " + err);
                        console.log(err.response);
                        EventBus.$emit("logon", false);
                    })
            }
        }
    }
</script>

<style lang="css" scoped>
  .section-padding-top {
    padding-top:50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue